module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/name/prefix.js
// module id = 1031
// module chunks = 1